__turbopack_context__.v({
  "quantityInput": "PUtYcW_quantityInput",
});
